import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { FormBuilder, FormGroup, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/common/components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DirtyCheck } from 'src/app/common/guards/form-deactivate.guard';

import { StaffAttendanceService } from '../../staff-attendance.service';
import { staffAttendanceModel } from '../model/staffAttendanceModel.model';
import { EmployeeService } from 'src/app/pages/common/employees/employee/employee.service';

@Component({
  selector: 'app-staff-attendance-edit',
  standalone: false,
  templateUrl: './staff-attendance-edit.component.html',
  styleUrl: './staff-attendance-edit.component.scss'
})
export class StaffAttendanceEditComponent {
   title: string = "New Staff Attendance";
    editForm: FormGroup;
    staffAttendanceinfo: staffAttendanceModel = {};
    isFormDirty: boolean = false;
    ratingList : staffAttendanceModel[]= [];
    
    reasonOptions = [
      { value: 1, label: 'Forgot to clock in' },
      { value: 2, label: 'Forgot to clock out' },
      { value: 3, label: 'Clock in late' },
      { value: 4, label: 'Clock out early' },
      { value: 5, label: 'Clock in late and clock out early' },
      { value: 6, label: 'Others' }
    ];
    shiftOptions = [
      { value: 'daily_shift', label: 'Daily Shift' },
      
      // Add more as needed
    ];
    hoursList: string[] = Array.from({length: 24}, (_, i) => i.toString().padStart(2, '0'));
    mintList: string[] = Array.from({length: 60}, (_, i) => i.toString().padStart(2, '0'));

    shiftTimeDisplay: string = '03:00 ~ 10:00';
  areaId: number;

    // Custom validator to check if shift_start_date and shift_end_date are the same
    // static sameDateValidator(group: AbstractControl): ValidationErrors | null {
    //   const start = group.get('shift_start_date')?.value;
    //   const end = group.get('shift_end_date')?.value;
    //   if (start && end) {
    //     // Compare only the date part (ignore time)
    //     const startDate = new Date(start);
    //     const endDate = new Date(end);
    //     if (
    //       startDate.getFullYear() !== endDate.getFullYear() ||
    //       startDate.getMonth() !== endDate.getMonth() ||
    //       startDate.getDate() !== endDate.getDate()
    //     ) {
    //       return { datesNotMatch: true };
    //     }
    //   }
    //   return null;
    // }
static sameDateValidator(group: AbstractControl): ValidationErrors | null {
  const start = group.get('shift_start_date')?.value;
  const end = group.get('shift_end_date')?.value;

  if (start && end) {
    const startDate = new Date(start);
    const endDate = new Date(end);

    if (
      startDate.getFullYear() !== endDate.getFullYear() ||
      startDate.getMonth() !== endDate.getMonth() ||
      startDate.getDate() !== endDate.getDate()
    ) {
      group.get('shift_end_date')?.setErrors({ datesNotMatch: true });
      return { datesNotMatch: true };
    } else {
      // ✅ clear previous error if dates match
      const endCtrl = group.get('shift_end_date');
      if (endCtrl?.hasError('datesNotMatch')) {
        const errors = { ...endCtrl.errors };
        delete errors['datesNotMatch'];
        if (Object.keys(errors).length === 0) {
          endCtrl.setErrors(null);
        } else {
          endCtrl.setErrors(errors);
        }
      }
    }
  }
  return null;
}

    constructor(private router: Router,
      private builder: FormBuilder,
      private route: ActivatedRoute,
      private staffAttendceService: StaffAttendanceService,
      private snackBarService: SnackBarService,
       private employeeService: EmployeeService,
      public dialog: MatDialog,) {
      
  
      this.areaId = Number(this.route.snapshot.paramMap.get('id')) ;
      let staffId = this.route.snapshot.paramMap.get('id');
      this.editForm = this.builder.group({
        employee_name: this.builder.control(
          (this.staffAttendanceinfo.employee_name ? this.staffAttendanceinfo.employee_name : '') +
          (this.staffAttendanceinfo.employee_lname ? ' ' + this.staffAttendanceinfo.employee_lname : ''),
         
        ),
        shift: this.builder.control('', Validators.required),
        shift_start_date: this.builder.control(this.staffAttendanceinfo.shift_start_date, Validators.required),
        shift_start_hour: this.builder.control('', Validators.required),    // new
        shift_start_minute: this.builder.control('', Validators.required),  // new
        shift_end_date: this.builder.control(this.staffAttendanceinfo.shift_end_date, Validators.required),
        shift_end_hour: this.builder.control('', Validators.required),      // new
        shift_end_minute: this.builder.control('', Validators.required),    // new
        breakStart: this.builder.control(''),
        breakStartMint: this.builder.control(''), // new
        breakEnd: this.builder.control(''),
        breakEndMint: this.builder.control(''),   // new
        upbHour: this.builder.control(''),
        upbMinute: this.builder.control(''),
        upb: this.builder.control(this.staffAttendanceinfo.upb), // keep for compatibility
        mint: this.builder.control(''), // add mint control
        entry_reason: this.builder.control(this.staffAttendanceinfo.entry_reason,Validators.required),
        reasonDetail: this.builder.control(''),
        employee_id: this.builder.control(''),
      }, { validators: StaffAttendanceEditComponent.sameDateValidator });
    
if (!staffId || Number(staffId) === 0) {
  this.editForm.get('employee_id')?.setValidators([Validators.required]);
} else {
  this.editForm.get('employee_id')?.clearValidators();
}

this.editForm.get('employee_id')?.updateValueAndValidity();
      
      this.editForm.valueChanges.subscribe(() => {
        this.isFormDirty = true;
        // Clear reasonDetail if entry_reason is not "Others"
        if (this.editForm.get('entry_reason')?.value !== 6) {
          this.editForm.get('reasonDetail')?.setValue('');
        }
        // Sync upb field from hour/minute
        const hour = this.editForm.get('upbHour')?.value || '00';
        const minute = this.editForm.get('upbMinute')?.value || '00';
        this.editForm.get('upb')?.setValue(`${hour}:${minute}:00`, { emitEvent: false });
      });
  
      if (staffId !== null && parseInt(staffId) !== 0) {
        this.setStaffInfo(staffId);
      }
    }
    ngOnInit(): void {
      //  this.loadRating();
      this.loadEmployeeData();
      console.log(this.staffAttendanceinfo);
    }

    /**
     * Dirtyness check
     * @returns 
     */
    isDirty():boolean{
      return this.isFormDirty;
    }
  
    /**
     * checks the form is edited
     */
    navBack(): void {
     
        this.router.navigate(['/staff-attendance']);
      
    }
  
    /**
     * If tas is is null set an empty area info
     * if area id is not null call api to rtrive the info
     * @param areaId 
     */
    setStaffInfo(areaId: any): void {

      let response = this.staffAttendceService.getById(areaId).subscribe({
        next: (response) => {
          if (response.status == 'SUCCESS') {
            this.staffAttendanceinfo = response.data.staffAttendance;
            // Example: set shift time display (customize as needed)
            this.shiftTimeDisplay = '03:00 ~ 10:00'; // Set dynamically based on shift
            // Split shift_start_time and shift_end_time into hour/minute for dropdowns
            let startHour = '';
            let startMinute = '';
            let endHour = '';
            let endMinute = '';
            if (this.staffAttendanceinfo.shift_start_time) {
              const [h, m] = this.staffAttendanceinfo.shift_start_time.split(':');
              startHour = h;
              startMinute = m;
            }
            if (this.staffAttendanceinfo.shift_end_time) {
              const [h, m] = this.staffAttendanceinfo.shift_end_time.split(':');
              endHour = h;
              endMinute = m;
            }
            // Split unscheduled_breakout and unscheduled_breakin for Break Start/End
            let breakStartHour = '';
            let breakStartMinute = '';
            let breakEndHour = '';
            let breakEndMinute = '';
            if (this.staffAttendanceinfo.unscheduled_breakout) {
              const [h, m] = this.staffAttendanceinfo.unscheduled_breakout.split(':');
              breakStartHour = h;
              breakStartMinute = m;
            }
            if (this.staffAttendanceinfo.unscheduled_breakin) {
              const [h, m] = this.staffAttendanceinfo.unscheduled_breakin.split(':');
              breakEndHour = h;
              breakEndMinute = m;
            }
            if (this.staffAttendanceinfo.upb) {
              const [upbHour, upbMinute] = this.staffAttendanceinfo.upb.split(':');
              this.editForm.patchValue({
                upbHour: upbHour || '',
                upbMinute: upbMinute || ''
              });
            }
            this.editForm.patchValue({
              ...this.staffAttendanceinfo,
              employee_name: (this.staffAttendanceinfo.employee_name ? this.staffAttendanceinfo.employee_name : '') +
                             (this.staffAttendanceinfo.employee_lname ? ' ' + this.staffAttendanceinfo.employee_lname : ''),
              shift_start_hour: startHour,
              shift_start_minute: startMinute,
              shift_end_hour: endHour,
              shift_end_minute: endMinute,
              breakStart: breakStartHour,
              breakStartMint: breakStartMinute,
              breakEnd: breakEndHour,
              breakEndMint: breakEndMinute,
              entry_reason: this.staffAttendanceinfo.entry_reason 
            });
            // Ensure shift is set if missing
            if (!this.editForm.get('shift')?.value) {
              this.editForm.get('shift')?.setValue(this.shiftOptions[0]?.value || '');
            }
            this.title = this.getTitle();
            this.isFormDirty = false;

          } else {
            let snackBarData: SnackBarData = {
              message: response.message,
              title: 'Failed!!!',
              type: 'error'
            }
            this.snackBarService.openSnackBar(snackBarData);
          }
        },
        error: (error) => {
          let snackBarData: SnackBarData = {
            message: 'Failed to get data from server. Connection to the server failed.',
            title: 'Failed!!!',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
        }
      });
     
    }
  
    /**
     * 
     * @returns  the title for the dialog
     * sine the same dialog is used for edit and new, dynamically decide the title
     */
    // getTitle(): string {
    //   return "Staff Attendance Edit";
    // }
  getTitle(): string {
    let title = (this.staffAttendanceinfo.id == 0) ? "New Staff Attendance" : "Editing : " + this.staffAttendanceinfo.employee_name + ' ' + this.staffAttendanceinfo.employee_lname;
    return title;
  }
    /**
       * On save
       * if the details are valid call the api to update the changes.
       */
    save(): void {

      if (this.editForm.valid) {
        this.editForm.markAllAsTouched();

        // Build the payload in the required format
        const formValue = this.editForm.value;
        const staffAttendancePayload: staffAttendanceModel = {
          // Only set id if not zero
          ...(this.staffAttendanceinfo.id && this.staffAttendanceinfo.id !== 0 ? { id: this.staffAttendanceinfo.id } : {}),
          shift_start_date: formValue.shift_start_date,
          shift_start_time: `${formValue.shift_start_hour || '00'}:${formValue.shift_start_minute || '00'}:00`,
          shift_end_date: formValue.shift_end_date,
          shift_end_time: `${formValue.shift_end_hour || '00'}:${formValue.shift_end_minute || '00'}:00`,
          act_shift_start_time: this.staffAttendanceinfo.act_shift_start_time || '',
          act_shift_end_time: this.staffAttendanceinfo.act_shift_end_time || '',
          // Only include employee_id if areaId is 0 (new record)
          ...(this.areaId === 0 ? { employee_id: formValue.employee_id } : {}),
          employee_name: this.staffAttendanceinfo.employee_name || '',
          employee_lname: this.staffAttendanceinfo.employee_lname || '',
          station_name: this.staffAttendanceinfo.station_name || '',
          station_code: this.staffAttendanceinfo.station_code || '',
          // finalized_by_name: this.staffAttendanceinfo.finalized_by_name || null,
          upb: (formValue.upbHour && formValue.upbMinute)
            ? `${formValue.upbHour}:${formValue.upbMinute}:00`
            : '',
          unscheduled_breakout: formValue.breakStart && formValue.breakStartMint
            ? `${formValue.breakStart}:${formValue.breakStartMint}:00`
            : '',
          unscheduled_breakin: formValue.breakEnd && formValue.breakEndMint
            ? `${formValue.breakEnd}:${formValue.breakEndMint}:00`
            : '',
          entry_reason: formValue.entry_reason || ''
        };

        this.staffAttendceService.update(staffAttendancePayload).subscribe({
          next: (response) => {
            if (response.status == 'SUCCESS') {
              this.isFormDirty = false;
              let snckBarData: SnackBarData = {
                type: 'success',
                title: 'Saved',
                message: 'The record for ' +this.staffAttendanceinfo.employee_name + ' ' + this.staffAttendanceinfo.employee_lname + " has been updated succesfully."
              }
              this.snackBarService.openSnackBar(snckBarData);
              // this.router.navigate(['/kitchen']);
            } else {
              let snackBarData: SnackBarData = {
                message: response.message,
                title: 'Failed!!!',
                type: 'error'
              }
              this.snackBarService.openSnackBar(snackBarData);
              this.router.navigate(['/kitchen-edit']);
            }
          },
          error: (error) => {
            let snackBarData: SnackBarData = {
              message: 'Failed to update. Connection to the server failed',
              title: 'Failed!!!',
              type: 'error'
            }
            this.snackBarService.openSnackBar(snackBarData);
          }
        });

      } else {
        this.editForm.markAllAsTouched();
      }
    }
  
  employeeList: any[] = [];
      filteredEmployeeList: any[] = []; 
     loadEmployeeData(): void {
   
    let requestData = {"search":{"filters":{"simpleSearch":[],"advSearch":[],"scope":{"limit":1000,"offset":0}},"sort":[{"column":"l_name","order":"asc"}]}}
    let response = this.employeeService.getEmployeeList(requestData).subscribe(response => {
      if (response.status == 'SUCCESS') {
        // Sort employeeList by full name (f_name + m_name + l_name) ascending
        this.employeeList = response.data.employees.sort((a: any, b: any) => {
          const nameA = `${a.f_name || ''} ${a.m_name || ''} ${a.l_name || ''}`.trim().toLowerCase();
          const nameB = `${b.f_name || ''} ${b.m_name || ''} ${b.l_name || ''}`.trim().toLowerCase();
          return nameA.localeCompare(nameB);
        });
        this.filteredEmployeeList = this.employeeList.slice(); // Initialize filtered list
        console.log(this.employeeList);
      } else {
        let snackBarData: SnackBarData = {
          message: response.message,
          title: 'Failed!!!',
          type: 'error'
        }
        this.snackBarService.openSnackBar(snackBarData);
      }
        
    
    });
  
  }
}
